import { render, staticRenderFns } from "./IndividualSummaryModal.vue?vue&type=template&id=355d5554"
import script from "./IndividualSummaryModal.vue?vue&type=script&lang=js"
export * from "./IndividualSummaryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports